<template>
      <v-row class="parent-dash">
        <v-col cols="4">
          <v-card class="mx-auto card-dashboard">
            <v-list-item class="border-btm">
                <v-list-item-avatar tile size="80" color="notification-icon">
                  <img src="../../assets/img/svg/notification.svg"/>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="headline mb-1">Notifications</v-list-item-title>
                </v-list-item-content>            
            </v-list-item>
            <div class="card-data">
              <div class="info-col">Inbox</div>
              <!-- <div class="info-col">Sent Items</div> -->
            </div>
          </v-card>
        </v-col>
        <v-col cols="4">
          <v-card class="mx-auto card-dashboard">
            <v-list-item class="border-btm">
                <v-list-item-avatar tile size="80" color="health-icon">
                  <img src="../../assets/img/svg/add.svg"/>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="headline mb-1">Health</v-list-item-title>
                </v-list-item-content>            
            </v-list-item>
            <div class="card-data">
              <div class="info-col">Student Health</div>
              <div class="info-col">Leader Board</div>
            </div>
          </v-card>
        </v-col>
        <v-col cols="4">
          <v-card class="mx-auto card-dashboard">
            <v-list-item class="border-btm">
                <v-list-item-avatar tile size="80" color="result_analysis-icon">
                  <img src="../../assets/img/svg/result_analysis.svg"/>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="headline mb-1">Result Analysis</v-list-item-title>
                </v-list-item-content>            
            </v-list-item>
            <div class="card-data">
              <div class="info-col">Testwise Analysis</div>
              <div class="info-col">Cumulative Analysis</div>
            </div>
          </v-card>
        </v-col>
        <v-col cols="4">
          <v-card class="mx-auto card-dashboard">
            <v-list-item class="border-btm">
                <v-list-item-avatar tile size="80" color="profile-icon">
                  <img src="../../assets/img/svg/profile.svg"/>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="headline mb-1">My Settings</v-list-item-title>
                </v-list-item-content>            
            </v-list-item>
            <div class="card-data">
              <div class="info-col">Edit Info</div>
              <div class="info-col">Edit Picture</div>
            </div>
          </v-card>
        </v-col>
        <v-col cols="4">
          <v-card class="mx-auto card-dashboard">
            <v-list-item class="border-btm">
                <v-list-item-avatar tile size="80" color="upgrade-icon">
                  <img src="../../assets/img/svg/upgrade.svg"/>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="headline mb-1">Upgrade to Gold</v-list-item-title>
                </v-list-item-content>            
            </v-list-item>
            <div class="card-data">
              <div class="info-col">JEE Main</div>
              <div class="info-col">NEET</div>
              <div class="info-col">JEE Advanced</div>
              <div class="info-col">KVPY - SA</div>
            </div>
          </v-card>
        </v-col>
      </v-row>
</template>

<script>
export default {
  name: 'DashboardParent',
  // components: {
  //   HelloWorld
  // }
}
</script>
